import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { communityMessages as messages } from './communityMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Communities.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SelfPromoChipProps {
  allowsSelfPromo: boolean;
  dayOrThread: string | null;
}

/**
 * The self-promo signal of a community (design outreach r1). A named thread or day wins first
 * (violet "Promo thread" + the day): when a community allows self-promo ONLY in a thread, the thread
 * is the rule the artist must follow, so surfacing "Self-promo OK" alone would get them removed.
 * Otherwise green "Self-promo OK" when it is allowed anywhere, else the muted "No self-promo"
 * default. The default is "no", so we never tell an artist they may post where they would be banned.
 */
const SelfPromoChipComponent: React.FC<SelfPromoChipProps> = ({ allowsSelfPromo, dayOrThread }) => {
  const intl = useIntl();
  const hasThread = dayOrThread !== null && dayOrThread.trim() !== '';

  if (hasThread) {
    return (
      <span className={styles.promo}>
        <span className={clsx(shared.chip, shared.chipVio)}>{intl.formatMessage(messages.promoThread)}</span>
        <small className={styles.promoDay}>{dayOrThread}</small>
      </span>
    );
  }
  if (allowsSelfPromo) {
    return (
      <span className={styles.promo}>
        <span className={clsx(shared.chip, shared.chipPos)}>{intl.formatMessage(messages.promoOk)}</span>
      </span>
    );
  }
  return (
    <span className={styles.promo}>
      <span className={clsx(shared.chip, shared.chipMuted)}>{intl.formatMessage(messages.promoNo)}</span>
    </span>
  );
};

export const SelfPromoChip = TypedMemo(SelfPromoChipComponent);
